const app = document.querySelector<HTMLDivElement>('#app');
if (!app) throw new Error('missing #app root');

app.innerHTML = `
  <main class="boot">
    <h1 class="wordmark">lava &amp; glass</h1>
    <p class="whisper">still waking up</p>
  </main>
`;
